const app = {};

app.isi = app.isi || {};

app.isi.scrollAndToggle = (function () {
  const pageIsi = document.getElementById('main-isi');
  const stickyIsi = document.getElementById('sticky-isi');
  const scrollIsi = document.querySelectorAll('[data-isi-scroll]');
  const toggleIsi = document.querySelectorAll('[data-isi-toggle]');

  /**
   * scroll element to certain point on the page.
   * @param {domElement} elem - scrolling element
   * @param {*} style - element attribute
   * @param {*} unit - value unit
   * @param {*} from - starting value
   * @param {*} to - ending value
   * @param {*} time - interval
   * @param {boolean} prop
   */
  const animate = function (elem, style, unit, from, to, time, prop) {

    if (!elem) {
      return;
    }

    const start = new Date().getTime();
    const timer = setInterval(function () {
      const step = Math.min(1, (new Date().getTime() - start) / time);
      if (prop) {
        elem[style] = (from + step * (to - from)) + unit;
      } else {
        elem.style[style] = (from + step * (to - from)) + unit;
      }
      if (step === 1) {
        clearInterval(timer);
      }
    // eslint-disable-next-line no-magic-numbers
    }, 20);

    if (prop) {
      elem[style] = from + unit;
    } else {
      elem.style[style] = from + unit;
    }
  };

  const scrollToIsi = function() {
    const headerHeight = document.querySelector('.global-header').getBoundingClientRect().height;
    const pageIsiPosition = pageIsi.offsetTop - headerHeight;
    const interval = 350;

    animate(document.scrollingElement || document.documentElement, 'scrollTop', '', window.pageYOffset, pageIsiPosition, interval, true);

    pageIsi.focus();
  }

  const init = function () {
    if (window.location.hash == '#isi') {
      setTimeout(scrollToIsi, 500);
    }

    scrollIsi.forEach((element) => {
      element.addEventListener('click', function (e) {
        e.preventDefault();

        scrollToIsi();
      });
    });

    toggleIsi.forEach((element) => {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        
        if (stickyIsi.classList.contains('isi-collapsed')) {
          stickyIsi.classList.remove('isi-collapsed');
          stickyIsi.setAttribute('aria-expanded', 'true');
        } else {
          stickyIsi.classList.add('isi-collapsed');
          stickyIsi.setAttribute('aria-expanded', 'false');
        }
      });
    });
  };

  const public_interface = {
    init: init
  };

  return public_interface;
})();

export default () => {
  app.isi.scrollAndToggle.init();
};